"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayPaginationWithBasicItems = void 0;
var _icon = _interopRequireDefault(require("@clayui/icon"));
var _shared = require("@clayui/shared");
var _react = _interopRequireDefault(require("react"));
var _Pagination = require("./Pagination");
var _excluded = ["active", "activePage", "alignmentPosition", "ariaLabels", "defaultActive", "disabledPages", "disableEllipsis", "ellipsisBuffer", "ellipsisProps", "hrefConstructor", "onActiveChange", "onPageChange", "spritemap", "totalPages"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var ELLIPSIS_BUFFER = 2;
var ClayPaginationWithBasicItems = exports.ClayPaginationWithBasicItems = /*#__PURE__*/_react.default.forwardRef(function ClayPaginationWithBasicItems(_ref, ref) {
  var active = _ref.active,
    activePage = _ref.activePage,
    alignmentPosition = _ref.alignmentPosition,
    _ref$ariaLabels = _ref.ariaLabels,
    ariaLabels = _ref$ariaLabels === void 0 ? {
      link: 'Go to page, {0}',
      next: 'Go to the next page, {0}',
      previous: 'Go to the previous page, {0}'
    } : _ref$ariaLabels,
    defaultActive = _ref.defaultActive,
    _ref$disabledPages = _ref.disabledPages,
    disabledPages = _ref$disabledPages === void 0 ? [] : _ref$disabledPages,
    _ref$disableEllipsis = _ref.disableEllipsis,
    disableEllipsis = _ref$disableEllipsis === void 0 ? false : _ref$disableEllipsis,
    _ref$ellipsisBuffer = _ref.ellipsisBuffer,
    ellipsisBuffer = _ref$ellipsisBuffer === void 0 ? ELLIPSIS_BUFFER : _ref$ellipsisBuffer,
    _ref$ellipsisProps = _ref.ellipsisProps,
    ellipsisProps = _ref$ellipsisProps === void 0 ? {
      'aria-label': 'Show pages {0} through {1}',
      title: 'Show pages {0} through {1}'
    } : _ref$ellipsisProps,
    hrefConstructor = _ref.hrefConstructor,
    onActiveChange = _ref.onActiveChange,
    onPageChange = _ref.onPageChange,
    spritemap = _ref.spritemap,
    totalPages = _ref.totalPages,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (totalPages === 0) {
    totalPages = 1;
  }
  var _useControlledState = (0, _shared.useControlledState)({
      defaultName: 'defaultActive',
      defaultValue: defaultActive,
      handleName: 'onActiveChange',
      name: 'value',
      onChange: onActiveChange !== null && onActiveChange !== void 0 ? onActiveChange : onPageChange,
      value: typeof active === 'undefined' ? activePage : active
    }),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    internalActive = _useControlledState2[0],
    setActive = _useControlledState2[1];
  var previousPage = internalActive - 1;
  var previousHref = hrefConstructor && hrefConstructor(previousPage);
  var nextPage = internalActive + 1;
  var nextHref = hrefConstructor && hrefConstructor(nextPage);
  var pages = Array(totalPages).fill(0).map(function (_item, index) {
    return index + 1;
  });
  return /*#__PURE__*/_react.default.createElement(_Pagination.Pagination, _extends({}, otherProps, {
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_Pagination.Pagination.Item, {
    "aria-label": internalActive !== 1 ? (0, _shared.sub)(ariaLabels.previous, [previousPage]) : undefined,
    as: internalActive === 1 ? 'div' : undefined,
    disabled: internalActive === 1,
    href: previousHref,
    onClick: function onClick() {
      return setActive(previousPage);
    },
    role: previousHref || internalActive === 1 ? undefined : 'button'
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "angle-left"
  })), (ellipsisBuffer ? (0, _shared.getEllipsisItems)({
    EllipsisComponent: _Pagination.Pagination.Ellipsis,
    ellipsisProps: _objectSpread(_objectSpread({}, ellipsisProps), {}, {
      alignmentPosition: alignmentPosition,
      disabled: disableEllipsis,
      disabledPages: disabledPages,
      hrefConstructor: hrefConstructor,
      onPageChange: setActive
    }),
    items: pages
  }, ellipsisBuffer, internalActive - 1) : pages).map(function (page, index) {
    return /*#__PURE__*/_react.default.isValidElement(page) ? (/*#__PURE__*/_react.default.cloneElement(page, {
      key: "ellipsis".concat(index)
    })) : /*#__PURE__*/_react.default.createElement(_Pagination.Pagination.Item, {
      active: page === internalActive,
      "aria-label": (0, _shared.sub)(ariaLabels.link, [page]),
      disabled: disabledPages.includes(page),
      href: hrefConstructor && hrefConstructor(page),
      key: page,
      onClick: function onClick() {
        return setActive(page);
      }
    }, page);
  }), /*#__PURE__*/_react.default.createElement(_Pagination.Pagination.Item, {
    "aria-label": internalActive !== totalPages ? (0, _shared.sub)(ariaLabels.next, [nextPage]) : undefined,
    as: internalActive === totalPages ? 'div' : undefined,
    disabled: internalActive === totalPages,
    href: nextHref,
    onClick: function onClick() {
      return setActive(nextPage);
    },
    role: nextHref || internalActive === totalPages ? undefined : 'button'
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "angle-right"
  })));
});
ClayPaginationWithBasicItems.displayName = 'ClayPaginationWithBasicItems';